<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>



<div id="main">
    <router-outlet></router-outlet>
</div>


<button type="button" #openModal class="btn btn-primary" data-toggle="modal" data-target="#exampleModal" style="display: none;">
</button>

<!-- Modal -->
<div class="modal fade" id="exampleModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <button type="button" class="close" data-dismiss="modal" #close aria-label="Close" style="display: none;"></button>
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body p-0 text-center">
                <img src="assets/img/error.jpg" class="img-fluid">
                <h3 class="text-danger pb-3" *ngIf="!isConnected">{{status}}</h3>
                <h3 class="text-success  pb-3" *ngIf="isConnected">{{status}}</h3>
            </div>
        </div>
    </div>
</div>

<!-- <input type="hidden" class="btn btn-primary" data-toggle="modal" data-target="#sessionModal">
<div class="modal fade" id="sessionModal" tabindex="-1" aria-labelledby="sessionModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <p class="modal-title mb-0" id="sessionModalLabel">Session Expired</p>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body text-center">
                <img src="assets/img/sessionend.jpg" class="img-fluid w-50">
                <h5>Your Session Has Expired.</h5>
                <h6>Please Re-Login Again.</h6>
                <button type="button" class="btn btn-outline-success btn-sm px-5 my-3" data-dismiss="modal">OK</button>
            </div>
        </div>
    </div>
</div> -->